import {
  USER_CONNECTED_FETCH
} from '../constants/ActionTypes';

export function loadConnectedUser(user) {
  return {
    type: USER_CONNECTED_FETCH,
    user
  };
}